import { Lines, FadeUp, ImgReveal } from "../site/Reveal";
import { Btn, SectionLabel } from "../site/Btn";
import { useLang } from "../../i18n/lang";
import { useSiteImages } from "../../lib/siteImages";

const IMGS = [
  ["vision_1", "Natural stone slab", "md:mt-0"],
  ["vision_2", "Stone being worked", "md:mt-28"],
  ["vision_3", "Finished stone object in an interior", "md:mt-12"],
];

export const Vision = () => {
  const { t, to } = useLang();
  const img = useSiteImages();
  return (
    <section className="bg-[#F0F0F0] px-6 sm:px-10 lg:px-14 py-28 sm:py-36 lg:py-44" data-testid="vision-section">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-6">
          <SectionLabel n={3}>{t.vision.label}</SectionLabel>
          <Lines lines={[t.vision.title]} className="f-serif font-light tracking-[-0.02em] leading-[1] text-5xl sm:text-6xl lg:text-7xl mt-10" />
        </div>
        <FadeUp className="lg:col-span-5 lg:col-start-8 lg:pt-20">
          <p className="text-lg leading-[1.75] text-[#3A3A3A]">{t.vision.text}</p>
          <div className="mt-10"><Btn to={to("/start-a-project")} testid="vision-start-project">{t.common.startProject}</Btn></div>
        </FadeUp>
      </div>
      <div className="mt-20 lg:mt-28 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
        {IMGS.map(([key, alt, off], i) => (
          <div key={key} className={off}>
            <ImgReveal src={img(key)} alt={alt} className="aspect-[3/4]" delay={i * 0.12} />
            <div className="mt-5 flex items-baseline justify-between border-t border-[#1A1A1A]/20 pt-4">
              <span className="f-serif italic text-2xl font-light">{t.vision.steps[i]}</span>
              <span className="f-mono text-[0.7rem] text-[#555555]">{["I", "II", "III"][i]}</span>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-10 text-xs text-[#555555]">{t.common.illustrative}</p>
    </section>
  );
};
